import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = ({ message = "Loading..." }) => {
  return (
    <div className="min-h-screen min-w-full flex flex-col items-center justify-center bg-gray-100">
      <CircularProgress size={60} className="text-primary-blue" />
      <span className="mt-4 text-lg text-gray-700 font-semibold animate-pulse">
        {message}
      </span>
    </div>
  );
};

export default Loader;
